import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Container, Icon, Grid} from 'semantic-ui-react';

import {getPaaSSiteManagementLink, getAppCatalogueSiteManagementLink} from 'state/selectors';

import styles from './OkdConsoleLink.module.scss';

const OkdConsoleLink = ({projectType, projectName}) => {
  const paasSiteMgmLink = useSelector(getPaaSSiteManagementLink);
  const appCatalogueSiteMgmLink = useSelector(getAppCatalogueSiteManagementLink);

  return (
    <Container className={styles.OkdConsoleLink}>
      <Grid stackable>
        <Grid columns={1}>
          <Grid.Column textAlign="left">
            {projectType === 'paas' && (
              <a
                className={styles.ConsoleLink}
                href={`${paasSiteMgmLink}/${projectName}`}
                target="_blank"
                rel="noreferrer"
              >
                Access project through OKD console <Icon name="external alternate" size="small" />
              </a>
            )}
            {projectType === 'app-catalogue' && (
              <a
                className={styles.ConsoleLink}
                href={`${appCatalogueSiteMgmLink}/${projectName}`}
                target="_blank"
                rel="noreferrer"
              >
                Access project through OKD console <Icon name="external alternate" size="small" />
              </a>
            )}
          </Grid.Column>
        </Grid>
      </Grid>
    </Container>
  );
};

OkdConsoleLink.propTypes = {
  projectType: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
};

export default OkdConsoleLink;
